import { Box, Button, Portal } from "@chakra-ui/react";
import { ArrowBackIcon } from "@chakra-ui/icons";
import { useState } from "react";
import { useHistory, useLocation, useRouteMatch, Switch, Route, Redirect } from "react-router-dom";
import AddDriver from "./AddDriver";
import DriversList from "./DriversLIst";
import AdminNavbar from "components/Navbars/AdminNavbar";

const DriversContainer = () => {
  const history = useHistory();
  const location = useLocation();
  const match = useRouteMatch(); // e.g. /drivers
  const [editingCustomer, setEditingCustomer] = useState(null);

  // Track if we are on the "Add" screen
  const isAdd = location.pathname.endsWith("/add");
  const isEdit = location.pathname.includes("/edit");

  // ✨ Breadcrumbs logic
  const breadcrumbs = [
    {
      label: "Οδηγοί",
      onClick: () => history.push(match.url),
      isClickable: isAdd || isEdit,
      isCurrent: !(isAdd || isEdit),
    },
    ...(isAdd || isEdit
      ? [
        {
          label: isEdit ? "Επεξεργασία Οδηγού" : "ΠΡΟΣΘΗΚΗ ΟΔΗΓΟΥ",
          isClickable: false,
          isCurrent: true,
        },
      ]
      : []),
  ];

  const handleAddClient = () => {
    // Clear the localStorage and navigate to the "Add" screen
    localStorage.removeItem("driverData");  // Clear any pre-existing data
    history.push(`${match.url}/add`);
  };
  const handleEdit = (driver) => {
    setEditingCustomer(driver);
    localStorage.setItem("driverData", JSON.stringify(driver)); // Save to localStorage
    history.push(`${match.url}/edit/${driver.id}`);
  };


  const handleDelete = (driver) => {
    console.log("Delete clicked for:", driver);
  };

  const onAddDriverStatus = (status) => {
    if (status === true) {
      history.push(match.url);  // Go back to the driver list
    }
  };

  return (
    <>
      <Portal>
        <AdminNavbar
          logoText="Admin Dashboard"
          breadcrumbs={breadcrumbs}
        />
      </Portal>

      <Switch>
        <Route exact path={match.path}>
          <DriversList
            handleAddClient={handleAddClient}
            handleEdit={handleEdit}
            handleDelete={handleDelete}
          />
        </Route>

        <Route exact path={`${match.path}/add`}>
          {/* Pass driverData as null for "Add" screen */}
          <AddDriver
            driverData={null}
            onAddDriverStatus={onAddDriverStatus}
          />
        </Route>

        <Route exact path={`${match.path}/edit/:id`}>
          <AddDriver
            driverData={editingCustomer || JSON.parse(localStorage.getItem("driverData"))}
            onAddDriverStatus={onAddDriverStatus}
          />
        </Route>


        {/* Fallback to driver list for unknown routes */}
        <Redirect to={match.url} />
      </Switch>
    </>
  );
};

export default DriversContainer;
